import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { PosShift, PosShiftCreate, PosShiftFilter } from '../data/posShift';

export function createPosShiftService(client: AxiosInstance) {
  return createCrudService<PosShift, PosShiftCreate, PosShiftFilter>(
    client,
    '/restaurant/PosShift',
    'id',
  );
}

export type PosShiftService = CrudService<PosShift, PosShiftCreate, PosShiftFilter>;
